import React from 'react';
import PageComponent from './Page';

const Survey = ({
  nextClickHandler,
  onAnalyseResultsClick,
  menuItems,
  selectComponent,
  componentIndex,
  rules,
  backPath,
  onDone,
  test,
  locales,
  locales: {
    testing: {
      name,
      titles,
      testPlan: {
        header,
        survey: { text, title, footer, cardTitle, rate },
      },
    },
  },
}) => {
  return (
    <PageComponent
      cardName={cardTitle}
      handlers={[onAnalyseResultsClick ?? nextClickHandler, onDone]}
      title={title}
      locales={locales}
      text={text}
      footer={footer}
      name={name}
      header={header}
      stars={rate}
      test={test}
      titles={titles}
      menuItems={menuItems}
      selectComponent={selectComponent}
      componentIndex={componentIndex}
      rules={rules}
      backPath={backPath}
    />
  );
};

export default Survey;
